import ADD_HOME_VIDEO_REVIEW from "./addHomeVideoReview"
import PUBLISH_DRAFT_HOME_VIDEO_REVIEW from "./publishDraftHomeVideoReview"
import UPDATE_HOME_VIDEO_REVIEW from "./updateHomeVideoReview"

export default {
  ADD_HOME_VIDEO_REVIEW,
  PUBLISH_DRAFT_HOME_VIDEO_REVIEW,
  UPDATE_HOME_VIDEO_REVIEW
}
